// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./app/App";

// Critical brand font used on every page - loaded eagerly.
import "@fontsource/libre-baskerville/400.css";
import "@fontsource/libre-baskerville/700.css";
import "@fontsource/libre-baskerville/400-italic.css";
import "react-responsive-modal/styles.css";

// Global tokens, resets, and shared styles.
import "./app/styles/AppGlobal.css";
import "./app/styles/SharedComponentStyles.css";
import "./shared/components/filters/DropdownBase.css";
// segmented-toggle.css is imported by its component.

function Root() {
  return (
    <BrowserRouter
      future={{
        // Opt in to wrapping state updates in React.startTransition
        v7_startTransition: true,
        // Opt in to the new relative splat path resolution
        v7_relativeSplatPath: true,
      }}
    >
      <App />
    </BrowserRouter>
  );
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<Root />);
